<template>
    <div class="py-10">
        <header>
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h2 class="py-0.5 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:leading-9 sm:truncate">
                            {{ $t('New ticket') }}
                        </h2>
                    </div>
                    <div class="mt-4 flex md:mt-0 md:ml-4">
                        <router-link
                            class="btn bg-red-900 hover:bg-red-800 text-white shadow-sm rounded-md"
                            to="/tickets/list"
                        >
                            {{ $t('Return to tickets list') }}
                        </router-link>
                    </div>
                </div>
            </div>
        </header>
        <main>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-10 my-6 bg-white shadow overflow-hidden sm:rounded-md">
                    <loading :status="loading.form"/>
                    <form @submit.prevent="saveTicket">
                        <div class="bg-white md:grid md:grid-cols-3 px-4 py-5 gap-4">
                            <div class="md:col-span-2">
                                <div class="grid grid-cols-3 gap-6">
                                    <div v-if="departmentList.length > 0" class="col-span-3">
                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="department">{{ $t('Department') }}</label>
                                        <div class="mt-1 relative rounded-md shadow-sm">
                                            <input-select
                                                id="department"
                                                v-model="ticket.department_id"
                                                :options="departmentList"
                                                option-label="name"
                                                required
                                                @change="formGenerator(),getIndications(ticket.department_id)"
                                            />
                                        </div>
                                    </div>
                                    <div v-if="ticket.department_id" class="col-span-3">
                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="subject">{{ $t('Subject') }}</label>
                                        <div class="mt-1 relative rounded-md shadow-sm">
                                            <input
                                                id="subject"
                                                v-model="ticket.subject"
                                                :placeholder="$t('Subject')"
                                                class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                                required
                                            >
                                        </div>
                                    </div>
                                    <!-- Formulario dinamico -->
                                    <div class="col-span-3" >
                                        <div class="grid grid-cols-3 gap-6">
                                            <div v-for="item,index in formTicket" :key="item.id" class="col-span-3">
                                                <!-- Segun departamento -->
                                                <div >
                                                    <!-- Input select -->
                                                    <div v-if="item.type=='select'">
                                                        <label for="name" class="block text-sm font-medium leading-5 text-gray-700">{{item.label}}</label> 
                                                        <div class="mt-1 relative rounded-md shadow-sm">
                                                            <select v-model="item.data" :required="item.required==1" class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5" name="" id="">
                                                                <option disabled :value="null">Seleccione una opción</option>
                                                                <option v-for="option in item.select_options.split(',')" :value="option" :key="option" >{{option}}</option>
                                                            </select>
                                                            <!-- <input v-model="item.data" :type="item.type" id="name" :placeholder="item.label"  class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" spellcheck="false" data-ms-editor="true"> -->
                                                        </div>
                                                    </div>
                                                    <!-- Input tipo text -->
                                                    <div v-if="item.type=='text'">
                                                        <label for="name" class="block text-sm font-medium leading-5 text-gray-700">{{item.label}}</label> 
                                                        <div class="mt-1 relative rounded-md shadow-sm">
                                                            <input v-model="item.data" :type="item.type" id="name" :placeholder="item.label" :required="item.required==1" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" spellcheck="false" data-ms-editor="true">
                                                        </div>
                                                    </div>
                                                    <!-- Input tipo number -->
                                                    <div v-if="item.type=='number'">
                                                        <label for="name" class="block text-sm font-medium leading-5 text-gray-700">{{item.label}}</label> 
                                                        <div class="mt-1 relative rounded-md shadow-sm">
                                                            <input v-model="item.data" :type="item.type" id="name" :placeholder="item.label" :required="item.required==1" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" spellcheck="false" data-ms-editor="true">
                                                        </div>
                                                    </div>
                                                    <!-- Input tipo file -->
                                                    <div v-if="item.type=='file'">
                                                        <label for="name" class="block text-sm font-medium leading-5 text-gray-700">{{item.label}}</label> 
                                                        <div class="mt-1 relative rounded-md shadow-sm">
                                                            <input  ref="fileInput" :type="item.type" id="name" @change="uploadFile($event,index)" :placeholder="item.label" :required="item.required==1" class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5" spellcheck="false" data-ms-editor="true">
                                                        </div>
                                                    </div>
                                                    <!-- Input tipo textarea -->
                                                    <div v-if="item.type=='textarea'">
                                                        <label class="block text-sm font-medium leading-5 text-gray-700" for="ticket_body">{{item.label}}</label>
                                                        <div class="mt-1 relative rounded-md shadow-sm">
                                                            <input-wysiwyg
                                                                id="ticket_body"
                                                                v-model="item.data"
                                                                :plugins="{images: true, attachment: false}"
                                                                @selectUploadFile="selectUploadFile"
                                                            >
                                                                <template v-slot:top>
                                                                    <div :class="{'bg-gray-200': uploadingFileProgress > 0}" class="h-1 w-full">
                                                                        <div :style="{width: uploadingFileProgress + '%'}" class="bg-red-900 py-0.5"></div>
                                                                    </div>
                                                                </template>
                                                            </input-wysiwyg>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-if="ticket.attachments.length > 0" class="col-span-3">
                                        <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-2">
                                            <template v-for="(attachment, index) in ticket.attachments">
                                                <attachment :details="attachment" v-on:remove="removeAttachment(index,attachment)"/>
                                            </template>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- Indicaciones -->
                            <div v-if="formTicket.length > 0" class="md:col-span-1 gap-4">
                                <figure class="bg-red-100 rounded-md p-8">
                                    <div>
                                        <label class="block text-sm font-medium leading-5 text-gray-700">DEFINICIÓN DEL TRAMITE</label> 
                                        <div id="htmldef" class="mt-1 relative rounded-md ">
                                            <p  class="text-gray-700 ticket-reply-body" v-html="department.definition"/>
                                        </div>
                                    </div>
                                </figure>
                            </div>
                        </div>
                        
                        <div class="bg-gray-100 px-4 py-3 sm:px-6 ">
                            <div class="inline-flex">
                                <button
                                    class=" bg-red-900 hover:bg-red-800 text-white btn shadow-sm rounded-md"
                                    type="submit"
                                >
                                    {{ $t('Create ticket') }}
                                </button>
                            </div>
                        </div>
                    </form>
                    <!-- <input ref="fileInput" hidden type="file" accept="application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint,text/plain, application/pdf, image/*" @change="uploadFile($event)"> -->
                </div>
            </div>
        </main>
    </div>
</template>
<style>
div#htmldef > p > ul {
  list-style: disc !important;
  margin: 0 ; 
  /* padding: 0; */
  padding-left: 1.25rem;
}
div#htmldef > p > ol {
  list-style: auto !important;
  margin: 0 ; 
  /* padding: 0; */
  padding-left: 1.25rem;
}
</style>
<script>
export default {
    name: "index",
    metaInfo() {
        return {
            title: this.$i18n.t('New ticket'),
        }
    },
    data() {
        return {
            loading: {
                form: false,
                file: false,
            },
            department:{},
            uploadingFileProgress: 0,
            ticket: {
                subject: null,
                department_id: null,
                body: [],
                attachments: [],
            },
            formTicket:[],
            departmentList: [],
        }
    },
    mounted() {
        this.getDepartments();
    },
    methods: {
        getIndications(department){
            this.department= this.departmentList.find(x => x.id === department);
        },
        formGenerator(){
            axios.post('api/tickets/fields',this.ticket).then(res=>{
                this.formTicket = res.data;
            })
        },
        getDepartments() {
            const self = this;
            self.loading.form = true;
            axios.get('api/tickets/departments').then(function (response) {
                self.departmentList = response.data;
                self.loading.form = false;
            }).catch(function () {
                self.loading.form = false;
            });
        },
        saveTicket() {
            const self = this;
            self.loading.form = true;
            self.ticket.body=this.formTicket;
            axios.post('api/tickets', self.ticket).then(function (response) {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data saved correctly').toString(),
                    type: 'success'
                });
                this.ticket={}
                this.formGenerator()
            }).catch(function () {
                self.loading.form = false;
            });

            this.$router.push('/tickets/list');
        },

        selectUploadFile() {
            if (!this.loading.file) {
                this.$refs.fileInput.click();
            } else {
                this.$notify({
                    title: this.$i18n.t('Error').toString(),
                    text: this.$i18n.t('A file is being uploaded').toString(),
                    type: 'warning'
                });
            }
        },
        uploadFile(e,index) {
            const self = this;
            const formData = new FormData();
            self.loading.file = true;
            formData.append('file', e.target.files[0]);
            axios.post('api/tickets/attachments',formData,
                {
                    headers: {'Content-Type': 'multipart/form-data'},
                    onUploadProgress: function (progressEvent) {
                        self.uploadingFileProgress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
                    }.bind(this)
                }
            ).then(function (response) {
                self.loading.file = false;
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
                self.formTicket[index].data=response.data;
                self.ticket.attachments.push(response.data);
            }).catch(function () {
                self.loading.file = false;
                self.uploadingFileProgress = 0;
                self.$refs.fileInput.value = null;
            });
        },
        removeAttachment(indice,attachment) {
            this.ticket.attachments.splice(indice, 1);
            var name = 'C:\\fakepath\\'+attachment.name;
            var list = this.formTicket
            var index = list.map(x => {
                return x.data;
            }).indexOf(name);
            this.formTicket[index].data=null
        }
    }
}
</script>
